<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters()}` + $t('key1005383')" prop="name">
              <Input :placeholder="$t('key1000324')" clearable v-model.trim="pageParams.name"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--物流渠道-->
    <ymsLogisticsChannelModal ref="logisticsChannel" @updateData="updateData"></ymsLogisticsChannelModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import ymsLogisticsChannelModal from "@/views/yms/components/logisticsManage/ymsLogisticsChannelModal";
import {_handleMultilingualFields, setConfigCharacters} from "@/utils/common";

export default {
  name: "logisticsSettings",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        carrierId: null,
        shippingMethodId: null,
        merchantType: 2, /* 1 混合物流 2 分销商 3 供应商 */
        status: 1,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005379')}`,
          key: 'name',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            let name = params.row.name;
            return h('span', _handleMultilingualFields(name));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
          key: 'code',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          key: 'times',
          align: 'left',
          render(h, params) {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency < maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            } else {
              text = maxEfficiency + ' - ' + minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005310'),
          key: 'deliveryScope',
          align: 'left',
          render(h, params) {
            let list = params.row.deliveryScopeList || [];
            return h('div', list.join('、'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          width: 120,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('get_ymsLogisService'),
                    clickFn: () => {
                      v.$refs['logisticsChannel'].initYmsLogisticsChannelData('look', params.row.ymsLogisServiceId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: []
    };
  },
  created() {
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsLogisService_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsLogisService_query, JSON.stringify(v.pageParams)).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
            if (v.tableData.length > 0) {
              v.tableData.map((item) => {
                let newList = [];
                let carrierShippingMethodPriceModelZones = item.ymsLogisServicePriceModel.carrierShippingMethodPriceModelZones;
                let carrierShippingMethodPriceModelZoneCountryList = [];
                if (carrierShippingMethodPriceModelZones) {
                  let isAllCountries = carrierShippingMethodPriceModelZones.some((talg) => {
                    return talg.name === '0';
                  });
                  if (isAllCountries) {
                    newList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005242')];
                    item['deliveryScopeList'] = newList;
                  } else {
                    carrierShippingMethodPriceModelZones.map((ele) => {
                      if (ele.carrierShippingMethodPriceModelZoneCountryList && ele.carrierShippingMethodPriceModelZoneCountryList.length > 0) {
                        carrierShippingMethodPriceModelZoneCountryList.push(...ele.carrierShippingMethodPriceModelZoneCountryList);
                      }
                    });
                    if (carrierShippingMethodPriceModelZoneCountryList.length > 0) {
                      carrierShippingMethodPriceModelZoneCountryList.map((k) => {
                        newList.push(k.cnName);
                      });
                      item['deliveryScopeList'] = v.uniqueFunc(newList);
                      
                    }
                  }
                }
              });
            }
          } else {
            v.tableData = [];
            v.total = 0;
            v.pageParamsStatus = false;
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.carrierId = null;
      v.pageParams.shippingMethodId = null;
      v.getList();
    },
    // 新增、编辑物流渠道成功后，更新列表数据
    updateData() {
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    ymsLogisticsChannelModal
  }
};
</script>

<style scoped>

</style>
